import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { fetchUserClientId } from "@/lib/userAccess";
import { Loader2 } from "lucide-react";
import Landing from "@/pages/Landing";

export const SmartRedirect = () => {
  const { user, loading: authLoading, isAdmin } = useAuth();
  const [redirectPath, setRedirectPath] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!authLoading && user) {
      determineRedirect();
    } else if (!authLoading && !user) {
      setRedirectPath(null);
      setLoading(false);
    }
  }, [user, authLoading, isAdmin]);

  const determineRedirect = async () => {
    if (!user) return;

    try {
      // If admin, go to dashboard
      if (isAdmin) {
        setRedirectPath("/dashboard");
        return;
      }

      const clientId = await fetchUserClientId(user.id);
      setRedirectPath(clientId ? `/clients/${clientId}` : "/dashboard");
    } catch (error) {
      console.error("Error determining redirect:", error);
      setRedirectPath("/dashboard");
    } finally {
      setLoading(false);
    }
  };

  if (authLoading || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user || !redirectPath) {
    return <Landing />;
  }

  return <Navigate to={redirectPath} replace />;
};
